import React from 'react'
import { Form, Formik } from 'formik'
import Div from '@jumbo/shared/Div'
import Divider from '@mui/material/Divider'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import JumboAppTextField from '@jumbo/components/JumboAppTextField'
import LoadingButton from '@mui/lab/LoadingButton'
import SearchIcon from '@mui/icons-material/Search'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded'
import { useMediaQuery } from '@mui/material'
import { useJumboTheme } from '@jumbo/hooks'

const FamilyGridSidebarFilter = ({ mutation, display, filterIconColor }) => {
    const { theme } = useJumboTheme()
    const sm = useMediaQuery(theme.breakpoints.down('sm'))

    let initialValues = {
        familyName: '',
        firstName: '',
    }
    const onFormSubmit = (familyName, firstName) => {
        mutation.mutate({
            familyName: familyName,
            firstName: firstName,
            sort: 'familyName',
            isDescending: false,
        })
    }

    const onFilterSubmit = (data, { setSubmitting }) => {
        setSubmitting(true)
        onFormSubmit(data.familyName, data.firstName)
        setSubmitting(false)
    }

    return (
        <Formik
            validateOnChange={true}
            initialValues={initialValues}
            onSubmit={onFilterSubmit}
            onReset={onFilterSubmit}>
            {({ isSubmitting }) => (
                <Form noValidate autoComplete='off'>
                    <JumboCardQuick noWrapper sx={{ display: display, borderRadius: 0 }}>
                        <Divider />
                        <Div
                            className='grid-filter-parent'
                            style={{ display: 'flex', margin: '0% 1.5% 4% 1.5%', flexWrap: 'wrap' }}>
                            <Div sx={{ mr: 3, mt: 1.5 }}>
                                <Div>
                                    <Typography>Family Name</Typography>
                                </Div>
                                <Div sx={{ mt: 0.5 }}>
                                    <JumboAppTextField
                                        style={{ width: sm ? 220 : 100 }}
                                        size='small'
                                        name='familyName'
                                    />
                                </Div>
                            </Div>
                            <Div sx={{ mr: 3, mt: 1.5 }}>
                                <Div>
                                    <Typography>First Name</Typography>
                                </Div>
                                <Div sx={{ mt: 0.5 }}>
                                    <JumboAppTextField
                                        style={{ width: sm ? 220 : 100 }}
                                        size='small'
                                        name='firstName'
                                    />
                                </Div>
                            </Div>
                            <Div className='grid-filter-Button' sx={{ mt: 4.5 }}>
                                <Stack direction={'row'} spacing={1}>
                                    <Div>
                                        <LoadingButton
                                            size={'small'}
                                            type='submit'
                                            onClick={() => filterIconColor(true)}
                                            variant={'contained'}
                                            loading={isSubmitting || mutation.isLoading}>
                                            <SearchIcon />
                                        </LoadingButton>
                                    </Div>
                                    <Div>
                                        <LoadingButton
                                            size={'small'}
                                            type={'reset'}
                                            onClick={() => filterIconColor(false)}
                                            variant={'contained'}>
                                            <AutorenewRoundedIcon />
                                        </LoadingButton>
                                    </Div>
                                </Stack>
                            </Div>
                        </Div>
                    </JumboCardQuick>
                </Form>
            )}
        </Formik>
    )
}

export default FamilyGridSidebarFilter
